/*
  globals moment
*/
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('datetimePicker', function() {

    /**
     * Check if number is defined
     *
     * @param value
     * return bool
     */
    var isValid = function(value) {
      return typeof value === 'number' && (value === 0 || value);
    };

    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/app/modules/demandmgr/static/tpl/datetime-picker.html',
      scope: {
        ngModel: '=',
        min: '=',
        max: '=',
        timezone: '=',
        disabled: '=',
        dateTitle: '=',
        timeTitle: '=',
        required: '@',
        name: '@',
        infoMsg: '@',
        defaultTime: '@', // leave empty if default time is NOW
      },
      link: function($scope, $element, $attrs) {
        $scope.wasInitialised = false;
        $scope.timezoneOffset = 0;

        $scope.maxInvalid = false;
        $scope.minInvalid = false;

        if ($scope.disabled) {
          $scope.titleDate = 'Date can not be changed';
          $scope.titleTime = 'Time can not be changed';
        } else {
          $scope.titleDate = $scope.titleTime = '';
        }

        const dateTimeFormat = 'MMM DD, YYYY HH:mm Z';
        const dateFormat = 'ddd, MMM DD, YYYY';
        const timeFormat = 'HH:mm';
        const pickerFormat = 'YYYY-MM-DD'; // format string for the picker;

        $scope.pickerDate = undefined;
        $scope.displayDate = undefined;

        var min = null;
        var max = null;
        var defaultTime = null;

        var $date = $($element[0]).find('input[name="date-calendar"]');
        var $time = $($element[0]).find('input[name="time-display"]');

        $scope.invalid = false;



        /**
         * On Timezone Change
         */
        $scope.$watch('timezone', function(newVal) {
          if (!newVal) {
            return;
          }
          console.log('timezone watched. NewVal: ' + newVal);
          if (newVal) {
            $scope.timezone = newVal;
            console.log('timezone ', $scope.timezone);

            printDates($scope.ngModel);


            if (isValid($scope.min)) {
              $scope.minDisplay = printDateTimeFormatted($scope.min, dateTimeFormat);
              $date.data('DateTimePicker').minDate(moment.utc($scope.min).format(pickerFormat));
            }

            if (isValid($scope.max)) {
              $scope.maxDisplay = printDateTimeFormatted($scope.max,dateTimeFormat);
              $date.data('DateTimePicker').maxDate(moment.utc($scope.max).format(pickerFormat));
            }
          }
        });

        /**
         * MIN TIME
         */
        $scope.$watch('min', function(newVal) {
          console.log('Min watched. New min: ' + newVal);
          console.log('$scope.ngModel: ' + $scope.ngModel);
          console.log('$scope.minInvalid: ' + $scope.minInvalid);
          console.log('Old min: ' + min);

          if (newVal) {
            min = newVal;
            $scope.minDisplay = printDateTimeFormatted(newVal, dateTimeFormat);
            $date.data('DateTimePicker').minDate(moment.utc(newVal).format(pickerFormat));

            if (
              $scope.minInvalid || // if already invalidated, we still need to update the datetime in error message
              ($scope.ngModel && min > $scope.ngModel)
            ) {
              console.log('$scope.ngModel < min. $scope.ngModel = undefined; $scope.minInvalid = true');
              $scope.ngModel = undefined;
              $scope.displayDate = '';
              $scope.invalid = 'Min. Date: ' + printDateTimeFormatted(newVal, dateTimeFormat);
              $scope.minInvalid = true;
            }
          } else {
            min = null;
          }
        });

        /**
         * MAX TIME
         */
        $scope.$watch('max', function(newVal) {
            console.log('Max watched. New max: ' + newVal);
            console.log('$scope.ngModel: ' + $scope.ngModel);
            console.log('$scope.maxInvalid: ' + $scope.maxInvalid);
            console.log('Old max: ' + max);

            if (newVal) {
            max = newVal;
            //var maxToPrint = max - $scope.timezoneOffset;

            if ($scope.min && newVal < $scope.min) {
              // max can not be less than min
              max = null;
              return;
            }

            $scope.maxDisplay = printDateTimeFormatted(newVal, dateTimeFormat);
            $date.data('DateTimePicker').maxDate(moment.utc(newVal).format(pickerFormat));

            if ($scope.maxInvalid || ($scope.ngModel && max < $scope.ngModel)) {
              $scope.ngModel = undefined;
              $scope.displayDate = '';
              $scope.maxInvalid = true;
              $scope.invalid = 'Max. Date: ' + printDateTimeFormatted(newVal, dateTimeFormat);
            }
          } else {
            max = null;
          }
        });

        /**
         * Angular init
         */
        $scope.$watch('ngModel', function(newVal) {
            console.log('ngModel watched. New ngModel: ' + newVal);
            console.log('$scope.wasInitialised: ' + $scope.wasInitialised);

          if (!isValid(newVal) && !$scope.wasInitialised) {
            // first init
            $scope.timeDisplay = (
                $scope.defaultTime
                    ? moment.utc($scope.defaultTime, timeFormat)
                    : moment.tz(Date.now(), $scope.timezone).seconds(0).milliseconds(0)
            ).format(timeFormat);
            $scope.wasInitialised = true;
            return;
          } else if (!isValid(newVal) && $scope.wasInitialised) {
            return;
          }
          printDates(newVal);
          //console.log('utc ts: ' +newVal, moment.tz(newVal, "UTC").format("YYYY-MM-DD HH:mm:ss Z"), moment.tz(newVal, $scope.timezone).format("YYYY-MM-DD HH:mm:ss Z"), "user timezone",  $scope.timezone);
        });

        function printDateTimeFormatted(utcDateTimeMilliseconds, displayFormat) {
          if (!isValid(utcDateTimeMilliseconds)) {
            return '';
          }
           //console.log("printDateTimeFormatted", utcDateTimeMilliseconds, displayFormat, $scope.timezone, moment.tz(utcDateTimeMilliseconds, $scope.timezone).format(displayFormat));

          return moment.tz(utcDateTimeMilliseconds, $scope.timezone).format(displayFormat);
        }




        function printDates(utcDateTimeMilliseconds) {
          if ($scope.wasInitialised) {
            $scope.pickerDate = printDateTimeFormatted(utcDateTimeMilliseconds, pickerFormat);
            $scope.displayDate = printDateTimeFormatted(utcDateTimeMilliseconds, dateFormat);
          }
           $scope.timeDisplay = printDateTimeFormatted(utcDateTimeMilliseconds, timeFormat);
        }

        function validate(utcDateTimeMilliseconds) {
          if (utcDateTimeMilliseconds === 0) {
            $scope.invalid = undefined; // some inputs are empty - nothing to do here
            $scope.maxInvalid = false;
            $scope.minInvalid = false;

            return false;
          } else if (utcDateTimeMilliseconds === -1) {
            $scope.invalid = 'Please enter a valid time';
            $scope.maxInvalid = false;
            $scope.minInvalid = false;

            return false;
          } else if (min && min > utcDateTimeMilliseconds) {
            $scope.invalid = 'Min. Date: ' + printDateTimeFormatted(min, dateTimeFormat);
            $scope.minInvalid = true;
            return false;
          } else if (max && max < utcDateTimeMilliseconds) {
            $scope.invalid = 'Max. Date: ' + printDateTimeFormatted(max, dateTimeFormat);
            $scope.maxInvalid = true;
            return false;
          }

          $scope.invalid = undefined;
          $scope.maxInvalid = false;
          $scope.minInvalid = false;

          return true;
        }

        function getUserInputInUtcMilliseconds() {
          var userDate = $date.val();
          var userTime = $time.val();

          if (!userTime.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)) {
            return -1;
          } else if (!userDate || !userTime) {
            return 0;
          }
          console.log("getUserInputInUtcMilliseconds", userDate + ' ' + userTime, pickerFormat + ' ' + timeFormat);
          var ts = moment.tz(userDate + ' ' + userTime, pickerFormat + ' ' + timeFormat, $scope.timezone).utc();
          //console.log('utc ts: ' + ts.valueOf(), ts.format("YYYY-MM-DDD HH:mm:ss Z"), "user timezone",  $scope.timezone);
          return ts.valueOf();
        }

        function onChangeHandler() {
          var utcMilliseconds = getUserInputInUtcMilliseconds();

          if (validate(utcMilliseconds)) {
            $scope.ngModel = utcMilliseconds;
          } else {
            $scope.ngModel = undefined;
          }
          $scope.$apply();
        }

        // init event listeners for date and time components
        $date.datetimepicker({
            format: pickerFormat,
            useCurrent: false,
            ignoreReadonly: true,
            debug: false,
          })
          .on('dp.change', function(event) {

            let momentDate = moment.utc($date.val(), pickerFormat);
            //console.log("dp.change", $date.val(), pickerFormat, momentDate.valueOf(), dateFormat, printDateTimeFormatted(momentDate.valueOf(), dateFormat));
            $scope.displayDate = printDateTimeFormatted(momentDate.valueOf(), dateFormat);
            onChangeHandler();
          });

        $time.on('change', onChangeHandler);
      },
    };
  });
})(window.angular);
